<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>


    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        height="100%" style="width: 100%" class="custom-tbl">
        <el-table-column type="selection" width="50"></el-table-column>
        <!-- <el-table-column type="index" width="80"></el-table-column> -->
        <el-table-column prop="TerminalId" label="校车标识" width></el-table-column>
        <el-table-column prop="TerminalName" label="校车名称" width></el-table-column>
        <el-table-column prop="DepartmentName" label="部门" width></el-table-column>
        <el-table-column prop="DriverName" label="司机名称" width></el-table-column>
        <el-table-column prop="DriverPhone" label="司机电话" width></el-table-column>
        <el-table-column prop="StopGpsTime" label="是否已复核" width="">
          <template slot-scope="scope">
            <el-tag :type="scope.row.StopGpsTime ? 'success' : 'danger'" disable-transitions>{{
              scope.row.StopGpsTime
                ?
                "是" : "否" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="GpsTime" label="开始接送时间	" width></el-table-column>
        <el-table-column prop="StopGpsTime" label="复核时间" width></el-table-column>
        <el-table-column prop="StopImageFile" label="复核图片" align="center" header-align="center">
          <template slot-scope="scope">
            <oss-media-thumbs :media="scope.row.StopImageFile" />
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right"></el-pagination>
      </el-col>
    </section>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getSchoolBusPickRecords } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      searchList: [
        {
          label: '日期',
          key: 'date',
          type: 'date'
        },
        {
          label: '校车名称',
          key: 'schoolBusName',
        }
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: "",
      BaseApiUrl: BaseApiUrl, //网络前缀
    };
  },
  computed: {
  },
  methods: {
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      let _this = this;
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
      };
      this.listLoading = true;
      //NProgress.start();
      getSchoolBusPickRecords(para).then(async (res) => {
        this.total = res.data.response.dataCount;
        const rows = res.data.response.data || [];
        await this.prefetchListOssMedia(rows, 'StopImageFile');
        this.users = rows;
        this.listLoading = false;
        //NProgress.done();
      });
    }
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

</style>
